var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-header'),_c('main',{staticClass:"pt-24"},[_c('status-comp')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }